<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-toolbar flat color="blue lighten-2" dark>
        <v-toolbar-title dark>Медиатека v2</v-toolbar-title>
        <v-file-input accept=".jpeg,.jpg,.png,.pdf,.ex4,.zip,.mov,.mp4" label="File input" v-model="files"></v-file-input>
        <v-btn depressed color="blue lighten-2" @click="submitFiles" :disabled="files == null">
            Загрузить
        </v-btn>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn fab depressed color="blue lighten-2" v-on="on">
                    <v-icon>help_outline</v-icon>
                </v-btn>
            </template>
            <span>Для загрузки новых файлов нажмите на кнопку "+"<br> и следуйте дальнейшим указаниям</span>
        </v-tooltip>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn fab depressed color="blue lighten-2" v-on="on" @click="$emit('updateAllLibrary')">
                    <v-icon>refresh</v-icon>
                </v-btn>
            </template>
            <span>Обновить медиатеку</span>
        </v-tooltip>
        <!--<v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn fab depressed v-on="on" color="blue lighten-2" @click="sendNotification">
                    &lt;!&ndash;href="https://vk.com/write-23067124" target="_blank" link>&ndash;&gt;
                    <v-icon>cloud_upload</v-icon>
                </v-btn>
            </template>
            <span>Перейти в диалог группы ВК и залить файлы</span>
        </v-tooltip>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn fab depressed v-on="on" color="blue lighten-2" @click="$emit('sendNotification')">
                    &lt;!&ndash;href="https://vk.com/write-23067124" target="_blank" link>&ndash;&gt;
                    <v-icon>add</v-icon>
                </v-btn>
            </template>
            <span>Загрузить изображение</span>
        </v-tooltip>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn fab depressed v-on="on" color="blue lighten-2" @click="$emit('addFileForWa')">
                    <v-icon>add</v-icon>WA
                </v-btn>
            </template>
            <span>Добавить файлы для WhatsApp</span>
        </v-tooltip>-->

        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn fab depressed v-on="on" :large="removeMode" color="blue lighten-2"
                       @click="$emit('changeRemoveMode')">
                    <v-icon>delete_outline</v-icon>
                </v-btn>
            </template>
            <span>Выбрать и удалить файлы из медиатеки</span>
        </v-tooltip>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn dark v-on="on" icon :large="removeMode" color="success" @click="$emit('exitRemoveMode')"
                       v-show="removeMode">
                    <v-icon>undo</v-icon>
                </v-btn>
            </template>
            <span>Выйти из режима удаления файлов из медиатеки</span>
        </v-tooltip>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon :large="removeMode" color="error" v-show="removeMode"
                       @click="$emit('deleteSelectedFiles')" :disabled="selected.length === 0">
                    <v-icon>delete_sweep</v-icon>
                </v-btn>
            </template>
            <span>Удалить выбранные файлы</span>
        </v-tooltip>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon
                       @click="$emit('save')" :disabled="!model || model.id == null">
                    <v-icon>save</v-icon>
                </v-btn>
            </template>
            <span>Сохранить</span>
        </v-tooltip>

        <v-snackbar
                v-model="paramsSnackbar.show"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-toolbar>
</template>

<script>
import axios from 'axios'
import constConf from '../../../../constconf.js'
export default {
    name: 'MediaLibraryToolbar',
    props: ['removeMode', 'selected', 'model'],
    data() {
        return {
            paramsSnackbar: { show: false, color: 'success', text: 'Успешно сохранено' },
            files: null
        }
    },
    methods: {
        sendNotification() {
            let bot = this.bot(this.$route.params['pathMatch'])
            let url = 'https://vk.com/gim' + bot.group_id + '?sel=' + this.user.id
            window.open(url)
            axios.defaults.withCredentials = true
            axios.get(constConf.message.url + '/send/service-vk/' + 1 + '?bot_id=' + bot.id).then(response => {
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get medialibrary ' + error)
            })
        },
        /**
         * Description: Загрузка файлов на сервер
         **/
        submitFiles() {
            let formData = new FormData()
            formData.append('file', this.files)
            this.$store.dispatch('messages/uploadImage', {
                botId: this.$route.params['pathMatch'],
                formData: formData
            }).then(response => {
                if (response.ok) {
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Файл успешно сохранен'
                    this.files = null
                    this.$emit('updateAllLibrary')
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Произошла ошибка при сохранении файла'
                }
                this.paramsSnackbar.show = true
            })
        }
    }
}
</script>

<style scoped>

</style>
